import { Link, type LinkProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';

type ButtonProps = {
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	to?: LinkProps['to'];
	viewTransition?: LinkProps['viewTransition'];
	className?: string;
	children: ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
	React.AnchorHTMLAttributes<HTMLAnchorElement>;

export function Button({ to, size = 'md', viewTransition, className = '', children, ...props }: ButtonProps) {
	const sizes: Record<NonNullable<ButtonProps['size']>, string> = {
		// xs: 'gap-1 p-1 text-xs',
		xs: 'gap-1 px-2 py-1.5 text-xs font-semibold',
		sm: 'gap-2 px-3 py-2 text-sm font-semibold',
		md: 'gap-3 px-4 py-3 font-semibold',
		lg: 'gap-4 px-5 py-4 text-lg font-bold',
		xl: 'gap-5 px-6 py-5 text-xl font-extrabold',
	};

	const classes = `
		${sizes[size]}
		border skin-bg-button skin-border-button skin-text-button skin-rounded-md flex w-fit items-center justify-center leading-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-200
		${className}
		disabled:opacity-40
`;

	if (to) {
		return (
			<Link {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)} to={to} viewTransition={viewTransition} className={classes}>
				{children}
			</Link>
		);
	}

	return (
		<button {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)} className={classes}>
			{children}
		</button>
	);
}
